import React from "react";
import { Row, Col, Typography, DatePicker } from "antd";

import totalUser from "media/total_users.png";
import newRegisteredUser from "media/new_registered_user_icon.png";
import promosGenerated from "media/promos_generated_icon.png";
import vouchersGenerated from "media/vouchers_generated_icon.png";
import moment from "moment";

const { RangePicker } = DatePicker;


const { Text } = Typography;

function DataCard(props) {
  return (
    <Row
      type="flex"
      gutter={[12, 12]}
      align="middle"
      style={{
        background: "#FFFFFF",
        border: "1px solid #F2F2F2",
        boxSizing: "border-box",
        padding: "10px 20px",
        borderRadius: "8px",
      }}
    >
      <Col>
        <img
          src={props.imgsrc}
          style={{
            width: "40px",
            height: "40px",
          }}
          alt={"Total users till date illustration"}
        />
      </Col>
      <Col>
        <Text style={{ fontSize: "20px", color: "black", fontWeight: "bold" }}>
          {props.data}
        </Text>
        <br />
        <Text
          style={{
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: "14px",
            lineHeight: "22px",
            color: "#747474",
          }}
        >
          {props.text}
        </Text>
      </Col>
    </Row>
  );
}

export default function TotalCustomerTillDate(props) {
  const {customerDetailsFilterDate,setCustomerDetailsFilterDate} = props;
  const cardDetails = [
    {
      imgSrc: totalUser,
      text: "Total Users",
      data: props.loading ? "..." : props.data?.total_users,
    },
    // {
    // 	imgSrc: newRegisteredUser,
    // 	text: "New Registered Users",
    // 	data: props.loading ? "..." : props.data?.newRegisteredUsers,
    // },
    {
      imgSrc: promosGenerated,
      text: "Promos Generated",
      data: props.loading ? "..." : props.data?.promos_generated,
    },
    {
      imgSrc: vouchersGenerated,
      text: "Vouchers Generated",
      data: props.loading ? "..." : props.data?.vouchers_generated,
    },
  ];

  return (
    <React.Fragment>
      <Row type="flex" align="middle" justify="space-between">
        <div>
          <Col>
            <Text
              style={{
                fontWeight: "bold",
                color: " #181818",
                fontSize: "18px",
                lineHeight: "24px",
              }}
            >
              Overall Analytics{" "}<br/>
            </Text>
            
            <Text
              style={{
                // fontWeight: "bold",
                color: " #181818",
                fontSize: "15px",
                lineHeight: "24px",
                display: props?.customerDetailsFilterDate?.start_date && props?.customerDetailsFilterDate?.end_date ? "inline" : "none" 
              }}
            >
              ( From {props?.customerDetailsFilterDate?.start_date} To {props?.customerDetailsFilterDate?.end_date} )
            </Text>
          </Col>
        </div>

        <RangePicker
                        style={{
                            width: "300px",
                            border: "1px solid rgb(0, 0, 0, 0.25)",
                            borderRadius: "5px",
                            alignItems: "left",
                        }}
                        bordered={true}
                        value={[
                            customerDetailsFilterDate?.start_date
                                ? moment(customerDetailsFilterDate?.start_date, "YYYY-MM-DD")
                                : null,
                            customerDetailsFilterDate?.end_date
                                ? moment(customerDetailsFilterDate?.end_date, "YYYY-MM-DD").subtract(1, "d")
                                : null,
                        ]}
                        onChange={(value) => {
                            setCustomerDetailsFilterDate({
                                start_date: value[0]?.format("YYYY-MM-DD") || "",
                                end_date: value[1]?.add(1, "d").format("YYYY-MM-DD") || "",
                            });
                        }}
                    />


      </Row>
      <Row
        type="flex"
        gutter={[32, 32]}
        style={{
          marginTop: "0px",
        }}
      >
        {cardDetails.map((cardDetail, index) => (
          <Col key={index} style={{ flexGrow: 1, flexBasis: 0 }}>
            <DataCard
              imgsrc={cardDetail.imgSrc}
              text={cardDetail.text}
              data={cardDetail.data}
            />
          </Col>
        ))}
      </Row>
    </React.Fragment>
  );
}
